import { SET_EDITCATEGORY } from '../actions';

const categoryedit = (state = [], action) => {
  switch (action.type) {
	case SET_EDITCATEGORY:
      return [...action.value];  
    default: return state;
  }
}

export default categoryedit;
